import { NodeId, NodeType} from "../../../../model/Graph";
import {CodyResponse} from "../../../Cody";
import {
  PlayshotApplyContext,
  PlayshotChanged,
  PlayshotChangedDiff,
  PlayshotChangedOperation,
  PlayshotChangedType
} from "../PlayshotChanged";
import {applySlices} from "./apply-slices";
import {PageDefinition} from "./page-definitions";

export class PageAdded implements PlayshotChanged {
  public readonly name: string;
  public readonly type: PlayshotChangedType = 'NewPage';
  public readonly operation: PlayshotChangedOperation = 'added';
  public readonly nodeId: NodeId;
  public readonly nodeType = NodeType.ui;
  public readonly diff: PlayshotChangedDiff;

  private newPage: PageDefinition;

  constructor(name: string, nodeId: string, page: PageDefinition) {
    this.name = name;
    this.nodeId = nodeId;
    this.diff = {
      new: page,
      old: null,
    };
    this.newPage = page;
  }

  public async apply(ctx: PlayshotApplyContext): Promise<AsyncIterable<CodyResponse>> {
    return applySlices(this.nodeId, this.newPage, ctx);
  }
}

